module.exports = __webpack_public_path__ + "img/dropdown-no-results.77dc0f58.png";